<template>
  <div class="page-container has-action">
    <van-nav-bar fixed title="充值" left-arrow @click-left="goableBack()" />
    <div class="recharge recharge_2">
      <div class="block">
        <div class="fs-18">充值金额</div>
        <van-field class="tian-amount mt-10" type="number" v-model="payForm.tradeAmount" @blur="setAmountInMin" :placeholder="rechargeTxt">
          <div slot="left-icon">￥</div>
        </van-field>
      </div>

      <div class="block mt-5">
        <van-field type="number" v-model="payForm.cardNo" label="银行卡" input-align="right" clearable placeholder="请输入银行卡号" />
        <van-field type="number" v-model="payForm.mobile" label="手机号" input-align="right" clearable placeholder="请输入银行预留手机号" />
        <van-field v-model="bankName" readonly clearable input-align="right" label="开户行" placeholder="请选择开户行" @click="bankPicker.show = true" right-icon="arrow-down" />
      </div>
    </div>

    <div class="page-action">
      <van-button class="payment-next-step" @click="onClickNext" type="danger" size="large">确定</van-button>
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker show-toolbar value-key="bankName" :columns="bankPicker.columns" :loading="bankPicker.loading" @cancel="bankPicker.show = false" @confirm="confirmBankPicker" />
    </van-popup>
    <BlEft v-model="eftShow" :payType="payType" title="金额超出上限 请使用线下转账"></BlEft>
  </div>
</template>

<script>
import * as PayApi from "@/api/pay";
import BlEft from "@/components/bl-eft";
import "./idx.less";
import {
  Tag,
  Col,
  NavBar,
  Button,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Field,
  Checkbox,
  Popup,
  Picker,
} from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    BlEft,
  },

  data() {
    return {
      bankName: "", //  开户行名, 例如: 中国银行
      rechargeTxt: "充值金额 1 元起",
      payForm: {
        tradeAmount: this.$route.query.amount, //  金额
        terminal: "H5", // 终端
        cardNo: "", //  银行卡号
        bankId: "", //   开户行
        mobile: "", //  银行预留手机号
      },
      bankPicker: {
        show: false,
        loading: false,
        columns: [],
      },
      payType: {},
      eftShow: false,
    };
  },

  beforeMount() {
    // 获得银行卡列表
    this.getBankList();
    PayApi.paytype()
      .then((data) => {
        this.payType = data;
      })
      .catch((e) => {
        Toast(e.msg || e.message);
      });
  },

  methods: {
    // 失去焦点，如果金额小于最小起购金额。自动填充最小起购金额
    setAmountInMin() {
      let amount = Number(this.payForm.tradeAmount);
      if (amount < 1) {
        Toast(this.rechargeTxt);
        this.payForm.tradeAmount = 1;
        return;
      }
    },

    // 表单验证
    getFormVerify() {
      let { tradeAmount, cardNo, mobile } = this.payForm;
      if (!tradeAmount) return "请输入竞买额！";
      if (!cardNo) return "请输入银行卡号！";
      if (!mobile) return "请输入银行预留手机号！";
    },

    onClickNext() {
      if (this.getFormVerify()) {
        Toast(this.getFormVerify());
        return;
      }
      this._showLoading();
      PayApi.recharge(this.payForm)
        .then((data) => {
          this._dismissLoading();
          if (!data) {
            Toast("服务器繁忙, 请稍后再试");
            return;
          }

          location.href = data;
        })
        .catch((e) => {
          this._dismissLoading();
          if (e.code == 2006) {
            //如果在线支付功能没有开启，就跳转到离线充值页面
            this.$toast({
              message: "本次充值超过银行限额，请使用线下转账充值",
              onClose: () => {
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath },
                });
              },
            });
            return;
          } else {
            Toast(e.msg || e.message);
          }
        });
    },

    getBankList() {
      this.bankPicker.loading = true;
      PayApi.banklist()
        .then((data) => {
          this.bankPicker.columns = data || [];
          this.bankPicker.loading = false;
        })
        .catch((e) => {
          Toast(e.msg || e.message);
        });
    },

    //   确认银行卡的开户行
    confirmBankPicker(value) {
      Object.assign(this.payForm, {
        bankId: value.id,
        quota: value.quota,
      });
      this.bankName = value.bankName;
      this.bankPicker.show = false;
    },

    onShowQuota() {
      Toast("查看限额");
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .tian-amount {
  .van-field__left-icon {
    font-weight: 600;
  }
  .van-field__left-icon,
  .van-field__control {
    font-size: 32px;
    line-height: 36px;
  }
}
</style>
